export { default as BOTStoreContactPage } from 'components/BOTStoreContactPage'

